import {RepoIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'

export function Nothing() {
  return (
    <Blankslate title="You don’t have write access to this repository yet">
      <Blankslate.Visual>
        <RepoIcon size={24} />
      </Blankslate.Visual>
      <Blankslate.Heading>This repository is empty.</Blankslate.Heading>
      <Blankslate.Description>
        Care to check out the{' '}
        <Link inline href="https://youtube.com/GitHub">
          GitHub Channel on YouTube
        </Link>{' '}
        while you wait?
      </Blankslate.Description>
    </Blankslate>
  )
}
